import { Channel } from "@/interfaces/channel";
import axios from "@/lib/axios";
import { useChannelStore } from "@/stores/channel";
import { useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";
import { watch } from "vue";

const getChannels = async () => {
  const { data } = await axios.get<Channel[]>(`/api/channels`);
  return data;
};

const useChannel = () => {
  const { data, isError, isLoading, refetch } = useQuery(
    ["channels"],
    getChannels,
  );
  const { setChannels, getChannel } = useChannelStore();
  const { channels } = storeToRefs(useChannelStore());

  watch(data, () => {
    if (data.value) {
      setChannels(data.value);
    }
  });

  return {
    isError,
    isLoading,
    data,
    channels,

    refetch: () => {
      setChannels([]);
      return refetch();
    },
    getChannel,
  };
};

export default useChannel;
